(function () {
  document.addEventListener("DOMContentLoaded", () => {
    displaySuggestedRecipes();
  });

  function displaySuggestedRecipes(){
    fetch(`https://api.meyernaturalfoods.com/api/v1/recipes/getsuggested?numberOfRecipes=3&productId=${$("#productSKU").val()}`,{
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then((response) => response.json())
    .then((response) => {
      if (typeof response !== "undefined" && response.length > 0) {
        //Display recipes
        let recipeHtml = "";
        recipeHtml += "<div class='row'>";
        
        for (let i = 0; i < response.length; i++) {
          recipeHtml += "<div class='col-md-4 suggested-recipe'>";
          recipeHtml += "<a href='/pages/recipe/" + response[i].url + "')'>";
          recipeHtml += "<figure>";
          recipeHtml += `<img alt='${response[i].title}' src='${response[i].mainImageFilePath}${response[i].mainImageFileName}' />`;
          recipeHtml += "<figcaption>" + response[i].title + "</figcaption>";
          recipeHtml += "</figure>";
          recipeHtml += "</a>";
          recipeHtml += "</div>";
        }

        recipeHtml += "</div>";

        document.getElementById("productSuggetedRecipes").innerHTML = recipeHtml;
      }
      else {
        document.querySelector(".suggested-recipes-container").classList.add("hidden");
      }
    })
    .catch((error) => {
      //console.log(error);
      document.querySelector(".suggested-recipes-container").classList.add("hidden");
    })
    .finally();
  }
}());